import { useRef } from 'react';
import { useSelector as useReduxSelector, EqualityFn } from 'react-redux';

import { useStateUpdateEnabled } from './StateUpdateEnabledContext';

export function useSelector<S = unknown, T = unknown>(
  selector: (state: S) => T,
  equalityFn?: EqualityFn<T> | { equalityFn?: EqualityFn<T> }
): T {
  const stateUpdateEnabled = useStateUpdateEnabled();

  const selectedRef = useRef<T>();

  const selected = useReduxSelector((state: S) => {
    if (stateUpdateEnabled || selectedRef.current === undefined) {
      const selected = selector(state);

      selectedRef.current = selected;
    }
    return selectedRef.current;
    // react-redux has two overloads (EqualityFn | UseSelectorOptions); our union doesn't match either
  }, equalityFn as EqualityFn<T>);

  // Code to debug what's changing
  // const lastSelectedRef = useRef<T>();
  // if (
  //   lastSelectedRef.current !== selected &&
  // ) {
  //   console.log('selected', lastSelectedRef.current, selected);
  //   lastSelectedRef.current = selected;
  // }

  return selected;
}
